module.exports = __webpack_public_path__ + "img/typehuman.3969bddb.png";